import React ,{useState,useEffect} from 'react'
import {fetchAds} from "../../services/ApiService"
import { handleApi } from '../../utils/authentication'
import { getPlatformImg } from '../../helpers/getImgSrc'
import { FaGreaterThan } from "react-icons/fa6";
import youtube from "../../assests/youtube.svg"
import { getPlatformName } from '../../helpers/getPlatformName';
import { UTMGenerateModal } from '../../components';
import LoadingSpinner from '../../components/client/LoadingSpinner';

const Ads = () => {
    const [activeTab,setActiveTab]=useState('google_ads')
    const [adsList,setAdsList]=useState([])
    const [platformId,setPlatformId]=useState(null)
    const [platforms,setPlatforms]=useState(null)
    const [generateUtmModal,setGenerateUtmModal]=useState(false)
    const [selectedAd,setSelectedAd]=useState({})
    const [loading,setLoading]=useState(false)

    const handleListAds=async ()=>{
        try{
          setLoading(true)
            let endpoint="list_all_ads"
            let method="POST"
            let headers={}
            let formData=new FormData()
            formData.append('platform_id',platformId)
            let result=await handleApi(endpoint,method,headers,formData)
          //  console.log(result)
            if(result?.success)
            {
                setAdsList(result?.data?.ads_list)
            }else{

            }
    

        }catch(e)
        {
            console.log(e)
        }finally{
          setLoading(false)
        }
    }

    const getPlatforms=async ()=>{
        try{
            let endpoint="get_platform_list"
            let method="GET"
            let headers={}
            let result=await handleApi(endpoint,method,headers,null)
           // console.log(result)
            if(result?.success)
            {
                
                setPlatforms(result?.data?.platforms)
                setPlatformId(result?.data?.platforms['Google Ads'])
                
            }

        }
        catch(e)
        {
            console.log(e)

        }
    }


    useEffect(()=>{
        getPlatforms()

    },[])
    useEffect(()=>{
        if(platformId!=null)
           handleListAds()

    },[platformId])






  return (
    <div className='campaigns'>
        {/* ads list tab */}
        <div className="row campaign_header_tab d-flex align-items-center mb-3">
        <div className="col-lg-10 col-md-12 p-0">
          <div className='d-flex gap-5 py-2'>
            {/* <span onClick={() => setActiveTab('all_campaigns')}>
              <p className={`mb-0 ${activeTab === "all_campaigns" && "campaign_header_tab_active"}`}>
                All Ads 
              </p>
              {activeTab === "all_campaigns" && <div style={{ border: 'solid 1px #7f56d9' }} />}
            </span> */}
            <span onClick={() => 
            {
                setActiveTab('google_ads')
                setPlatformId(platforms['Google Ads'])

            }
         
         

            }    >
              <div className={`d-flex align-items-center gap-2 py-2 ${activeTab === "google_ads" && "campaign_header_tab_active"}`}>
              <img src={getPlatformImg(platformId)} alt="" srcset=""    className="img-fluid  h-2 w-2" style={{height:'18px',width:'18px'}}/>
              <p className={`mb-0 `}>Google Ads </p>
              </div>
             
              {/* {activeTab === "google_ads" && <div style={{ border: 'solid 1px #7f56d9' }} />} */}
            </span>

            <span onClick={() => 
            {
                setActiveTab('youtube_ads')
                setPlatformId(platforms['Google Ads'])

            }
         
         

            }     >
              <div className={`d-flex align-items-center gap-2 py-2 ${activeTab === "youtube_ads" && "campaign_header_tab_active"}`}>
              <img src={youtube} alt="" srcset=""    className="img-fluid  h-2 w-2" style={{height:'18px',width:'18px'}}/>
              <p className={`mb-0 `}>Youtube Ads </p>
              </div>
             
              {/* {activeTab === "youtube_ads" && <div style={{ border: 'solid 1px #7f56d9' }} />} */}
            </span>


      
       
          </div>
        </div>
 
      </div>

        {/* add list */}
        {loading && <LoadingSpinner />}
        {
         !loading && adsList?.map((adDetails)=>{
            if(activeTab==="google_ads" && adDetails?.type_google_ads)
            {
              return      <div className="row px-1 py-3 mx-2 mt-1 mb-2 campaign_item_card border border-2" key={adDetails?.id}>
                              <div className="col-lg-12 col-md-12">
                                <div className="d-flex flex-wrap justify-content-between my-2 pb-2 border-bottom">
                                  <div className="d-flex align-items-center gap-2">
                                    <img
                                      src={getPlatformImg(platformId)}
                                      className="img-fluid social_media_img"
                                      alt=""
                                    />
                                    <p className="mb-0">{adDetails?.name} Post</p>
                                  </div>
                                  <span>{getPlatformName(platformId)} Platform</span>
                                </div>
                                <div className="row d-flex align-items-center mt-2">
                                  <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                                    <p className="mb-0">Type</p>
                                    <span>{adDetails?.type}</span>
                                  </div>
                                  <div className="col-12 d-flex gap-4 justify-content-end">
                                    <button
                                      onClick={()=>{
                                      //  console.log("Called")
                                        setGenerateUtmModal(true)
                                        setSelectedAd(adDetails)
                                      }}
                                      className="btn btn-primary btn-sm rounded-pill d-flex gap-2 align-items-center"
                                    >
                                      {adDetails?.utm_flag ? 'View UTM' : 'Generate UTM'} <FaGreaterThan />
                                    </button>
                                  </div>
                                </div>
                              </div>
                       </div>
            }
            if(activeTab==="youtube_ads" && adDetails?.type_youtube_ads)
              {
                return  <div className="row px-1 py-3 mx-2 mt-1 mb-2 campaign_item_card border border-2" key={adDetails?.id}>
                <div className="col-lg-12 col-md-12">
                  <div className="d-flex flex-wrap justify-content-between my-2 pb-2 border-bottom">
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={youtube}
                        className="img-fluid social_media_img"
                        alt=""
                      />
                      <p className="mb-0">{adDetails?.name} Post</p>
                    </div>
                    <span>Youtube Platform</span>
                  </div>
                  <div className="row d-flex align-items-center mt-2">
                    <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                      <p className="mb-0">Type</p>
                      <span>{adDetails?.type}</span>
                    </div>
                    <div className="col-12 d-flex gap-4 justify-content-end">
                      <button
                        onClick={()=>{
                         
                          setGenerateUtmModal(true)
                          setSelectedAd(adDetails)
                        }}
                        className="btn btn-primary btn-sm rounded-pill d-flex gap-2 align-items-center"
                      >
                        {adDetails?.utm_flag ? 'View UTM' : 'Generate UTM'} <FaGreaterThan />
                      </button>
                    </div>
                  </div>
                </div>
         </div>
  
              }
         
          })
        }

     <UTMGenerateModal 
     setGenerateUtmModal={setGenerateUtmModal}
     generateUtmModal={generateUtmModal}
     platform_id={platformId}
     selectedAd={selectedAd}
     campaign_name={selectedAd?.campaign_name}
     external_campaign_id={selectedAd?.campaign_id}
     handleListAds={handleListAds}
    
     
     
     
     
     />
    </div>
  )
}

export default Ads